import { gql } from 'graphql-request'

const getNextMentor = gql`
  query getNextMentor(
    $lang: [Locale!]!
    $id: ID
    $speakingLanguages: [SpeakingLanguages!]
  ) {
    mentors(
      locales: $lang
      where: {
        speakingLanguages_contains_some: $speakingLanguages
        id_not_contains: $id
      }
      first: 10
    ) {
      id
      slug
    }
  }
`
export default getNextMentor
